export enum DayOfWeekFlags {
    Sunday = 1 << 0,     // 1
    Monday = 1 << 1,     // 2
    Tuesday = 1 << 2,    // 4
    Wednesday = 1 << 3,  // 8
    Thursday = 1 << 4,   // 16
    Friday = 1 << 5,     // 32
    Saturday = 1 << 6,   // 64
}

export const dayColumns = [
    { flag: DayOfWeekFlags.Monday, name: "Monday" },
    { flag: DayOfWeekFlags.Tuesday, name: "Tuesday" },
    { flag: DayOfWeekFlags.Wednesday, name: "Wednesday" },
    { flag: DayOfWeekFlags.Thursday, name: "Thursday" },
    { flag: DayOfWeekFlags.Friday, name: "Friday" },
    { flag: DayOfWeekFlags.Saturday, name: "Saturday" },
    { flag: DayOfWeekFlags.Sunday, name: "Sunday" },
];

export const dayColumnsAbbreviated = [
    { flag: DayOfWeekFlags.Monday, name: "M" },
    { flag: DayOfWeekFlags.Tuesday, name: "T" },
    { flag: DayOfWeekFlags.Wednesday, name: "W" },
    { flag: DayOfWeekFlags.Thursday, name: "Th" },
    { flag: DayOfWeekFlags.Friday, name: "F" },
    { flag: DayOfWeekFlags.Saturday, name: "Sat" },
    { flag: DayOfWeekFlags.Sunday, name: "Sun" },
];